























import { Component, Vue } from 'vue-property-decorator';
import Breadcrumb from '../../components/Breadcrumb.vue';
import { UserViewModel, UserService } from '../../api/user';
@Component({
  components: {
    Breadcrumb,
  },
})
export default class ChangePassword extends Vue {
  private breadcrumbData = [{name: '修改密码'}];

  private service: UserService = new UserService();
  private data: UserViewModel = this.service.NewModel;

  private rules = {
    password: [
      {required: true, message: '请输入原密码', trigger: 'blur'},
      {min: 6, message: '密码至少需要六位', trigger: 'blur'},
    ],
    passwordn: [
      {required: true, message: '请输入新密码', trigger: 'blur'},
      {min: 6, message: '新密码至少需要六位', trigger: 'blur'},
    ],
    passwordc: [
      {required: true, message: '请输入确认密码', trigger: 'blur'},
      {min: 6, message: '确认密码至少需要六位', trigger: 'blur'},
      {validator: this.validatePass, trigger: 'blur' },
    ],
  };

  private validatePass(rule: any, value: any, callback: any) {
    if (value === '') {
      callback(new Error('请输入确认密码'));
    } else {
      if (value !== this.data.passwordn) {
        callback(new Error('两次输入密码不一致！'));
      }
      callback();
    }
  }

  private btnSave_OnClick() {
    (this.$refs.editForm as any).validate((valid: boolean) => {
      if (valid) {
        this.service.ChangePassword(this.data).then((response: any) => {
          (this.$refs.editForm as any).resetFields();
          this.$message.success('保存成功！新密码在下次登录时生效！');
        });
      }
    });
  }

}
